<template>
  <div class="text-primary fs-5 ms-4">
    {{ this.descricaoModel }}
  </div>
  <div class="table-responsive mb-5">
    <table
      :class="[isloading && 'overlay overlay-block']"
      class="table align-middle table-row-dashed fs-6 gs-3 dataTable no-footer border-bottom border-start border-end table-rounded pe-1 mb-5"
      id="kt_custom_table_filter"
      ref="kt_custom_table_filter"
      role="grid"
    >
      <thead class="table-secondary">
        <tr
          class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0"
          role="row"
        >
          <th tabindex="0" rowspan="1" colspan="1"></th>
          <th
            @click="this.$emit(`sort`, header.key, header.sortable)"
            :class="[
              header.sortable !== false && 'sorting',
              this.currentSort === `${header.key} desc` && 'sorting_desc',
              this.currentSort === `${header.key} asc` && 'sorting_asc',
            ]"
            tabindex="0"
            rowspan="1"
            colspan="1"
            style="cursor: pointer"
            class="fw-bold w-auto"
            v-for="(header, index) in getHeaders()"
            :key="index"
          >
            {{ header.descricao }}
          </th>
        </tr>
      </thead>
      <tbody class="fw-bold text-gray-600 h-auto">
        <template v-if="getItems.length">
          <template v-for="(item, index) in getItems" :key="index">
            <tr>
              <td style="font-size: 14px">
                <a v-if="getToggle(item).length > 0" @click="toggleRow(index)">
                  <span
                    v-if="openRows[index]"
                    class="svg-icon svg-icon-primary"
                  >
                    <inline-svg src="media/icons/duotune/general/gen036.svg" />
                  </span>
                  <span v-if="!openRows[index]" class="svg-icon">
                    <inline-svg src="media/icons/duotune/general/gen035.svg" />
                  </span>
                </a>
              </td>
              <td
                class="w-auto"
                v-for="(header, index) in getHeaders()"
                :key="index"
                :data-title="header.descricao"
              >
                <div
                  class="w-auto"
                  v-if="this.retornaTipoCampo(header.key) === `datetime-utc`"
                >
                  {{
                    this.$utils.formatarDataHoraFusoHorario(item[header.key])
                  }}
                </div>
                <div
                  class="w-auto"
                  v-else-if="this.retornaTipoCampo(header.key) === `datetime`"
                >
                  {{ this.$utils.formatarDataHora(item[header.key]) }}
                </div>
                <div
                  v-else-if="this.retornaTipoCampo(header.key) === `decimal`"
                >
                  {{ this.$utils.formatarNumero(item[header.key]) }}
                </div>
                <div class="text-nowrap w-auto" v-else>
                  {{ item[header.key] }}
                </div>
              </td>
            </tr>
            <tr v-if="openRows[index]">
              <td class="w-auto" :colspan="getHeaders().length + 1">
                <template
                  v-for="(subItem, subItemIndex) in item"
                  :key="subItemIndex"
                >
                  <div
                    v-if="
                      subItem &&
                      subItem !== null &&
                      isArrayOrObject(subItem) &&
                      transformArray(subItem).length > 0
                    "
                    :style="{
                      'max-width': this.getWidth(),
                    }"
                  >
                    <KTDatatableFilter
                      :data="transformArray(subItem)"
                      :model="getModel(subItemIndex)"
                      :descricaoModel="getDescricaoModel(subItemIndex)"
                    ></KTDatatableFilter>
                  </div>
                </template>
              </td>
            </tr>
          </template>
        </template>
        <template v-else>
          <tr class="odd">
            <td :colSpan="12" class="dataTables_empty">
              {{ emptyTableText }}
            </td>
          </tr>
        </template>
      </tbody>
      <div
        v-if="isloading"
        class="overlay-layer card-rounded bg-dark bg-opacity-5"
      >
        <div class="spinner-border text-primary" role="status"></div>
        <span class="ms-2">Aguarde, carregando...</span>
      </div>
    </table>
  </div>
</template>

<script>
export default {
  name: "KTDatatableFilter",
  emits: ["sort"],
  props: {
    data: { type: Array, required: true },
    model: { type: Object, required: true },
    descricaoModel: { type: String, required: false, default: "" },
    isloading: { type: Boolean, required: false, default: false },
    emptyTableText: { type: String, default: "Nenhum dado encontrado" },
    sortable: { type: Boolean, required: false, default: false },
    currentSort: { type: String, default: "" },
  },
  computed: {
    getItems() {
      return this.data;
    },
  },
  methods: {
    retornaTipoCampo(campo) {
      const tipo = this.model[campo]
        ? this.model[campo].tipo || "unknown"
        : "unknown";

      const tipoComplementar = this.model[campo]
        ? this.model[campo].tipoComplementar || "unknown"
        : "unknown";

      if (tipo === "object" || tipo === "array") {
        return "text";
      } else if (tipo.toUpperCase().includes("INT")) {
        return "number";
      } else if (tipo.toUpperCase().includes("STRING")) {
        return "text";
      } else if (tipo.toUpperCase().includes("DATETIME")) {
        if (tipoComplementar.toUpperCase().includes("UTC")) {
          return "datetime-utc";
        } else {
          return "datetime";
        }
      } else if (tipo.toUpperCase().includes("DECIMAL")) {
        return "decimal";
      } else {
        return "text";
      }
    },
    camposOrdenados(objeto) {
      const compararPorDescricao = (a, b) => {
        const descricaoA = a.toUpperCase();
        const descricaoB = b.toUpperCase();

        if (descricaoA < descricaoB) return -1;
        if (descricaoA > descricaoB) return 1;
        return 0;
      };

      const arrayDePares = Object.entries(objeto);

      arrayDePares.sort((a, b) => compararPorDescricao(a[0], b[0]));

      const objetoOrdenado = Object.fromEntries(arrayDePares);

      return objetoOrdenado;
    },
    getHeaders() {
      if (this.data.length > 0) {
        const firstItem = this.camposOrdenados(this.data[0]);
        const keys = Object.keys(firstItem);

        const filteredKeys = keys
          .map((key) => {
            const value = firstItem[key];
            if (!this.isArrayOrObject(value) && this.model[key]) {
              const header =
                this.model[key] && this.model[key].descricao
                  ? this.model[key].descricao
                  : key;
              return {
                key: key,
                descricao: header,
                sortable: this.sortable,
              };
            } else {
              return "";
            }
          })
          .filter((item) => {
            return item !== "" && item !== "color";
          });

        return filteredKeys;
      }
      return [];
    },
    getToggle(item) {
      const keys = Object.keys(item);

      var filteredKeys = keys
        .map((key) => {
          const value = item[key];
          if (this.isArrayOrObject(value) && this.model[key]) {
            if (value instanceof Array) {
              return value.length > 0 ? key : "";
            } else {
              return key;
            }
          } else {
            return "";
          }
        })
        .filter((item) => {
          return item !== "";
        });

      return filteredKeys;
    },
    toggleRow(index) {
      this.openRows[index] = !this.openRows[index];
    },
    isArrayOrObject(item) {
      if (
        item &&
        item !== null &&
        (item instanceof Array || typeof item === "object")
      ) {
        return true;
      } else {
        return false;
      }
    },
    transformArray(item) {
      if (item instanceof Array) {
        return item;
      } else if (typeof item === "object") {
        var array = [];
        array.push(item);
        return array;
      } else {
        return item;
      }
    },
    getModel(subItemIndex) {
      return this.model[subItemIndex] && this.model[subItemIndex].items
        ? this.model[subItemIndex].items
        : {};
    },
    getDescricaoModel(subItemIndex) {
      return this.model[subItemIndex] && this.model[subItemIndex].descricao
        ? this.model[subItemIndex].descricao
        : "";
    },
    getWidth() {
      const tablePrincipal = this.$refs.kt_custom_table_filter;
      if (tablePrincipal) {
        const larguraTabelaPrincipal = tablePrincipal.offsetWidth - 25;
        return larguraTabelaPrincipal + "px";
      }
    },
  },
  data() {
    return {
      openRows: new Array(this.data.length).fill(false),
    };
  },
};
</script>

<style lang="scss">
table.dataTable {
  clear: both;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  max-width: none !important;
  border-collapse: separate !important;
  border-spacing: 0;
}

table.dataTable > thead {
  th.sorting {
    position: relative;
  }
  .sorting:after {
    position: absolute;
  }
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: none;
  border-radius: 0.475rem;
  font-weight: 500;
  font-size: 1.075rem;
  font-family: Poppins, Helvetica, sans-serif;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #009ef7;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
}

div.dataTables_wrapper div.dataTables_processing {
  position: absolute;
  top: 50%;
  left: 50%;
}

table.dataTable {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

th,
thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

@media only screen and (max-width: 768px) {
  #no-more-tables table,
  #no-more-tables thead,
  #no-more-tables tbody,
  #no-more-tables th,
  #no-more-tables td,
  #no-more-tables tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  #no-more-tables tbody {
    border: 0px solid rgb(235, 235, 235);
  }

  #no-more-tables table {
    border: 0px solid rgb(235, 235, 235);
  }

  #no-more-tables thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  #no-more-tables tr {
    margin-bottom: 18px;
  }

  #no-more-tables tr:nth-child(even) {
    border-left: 0px solid rgb(133, 189, 226);
  }

  #no-more-tables tr:nth-child(odd) {
    border-left: 0px solid rgb(152, 126, 212);
  }

  #no-more-tables td {
    //display: flex;
    width: 100%;
    border-bottom: 0px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  #no-more-tables td:before {
    content: attr(data-title);
    display: block;
    color: #999;
    top: 6px;
    left: 5px;
    min-width: 25%;
    padding-right: 0.8em;
    white-space: nowrap;
    text-align: left;
    font-weight: bold;
    font-size: 1.2vh;
  }
}
</style>
